import { LinearGradient } from "expo-linear-gradient";
import { useContext, useEffect, useState } from "react";
import {
  Alert,
  Dimensions,
  Image,
  Linking,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { UserContext } from "../globalData/UserContext";
import { globalStyles } from "../styles/globalStyles";
import ChooseAvatar from "./components/ChooseAvatar";
import { Ionicons } from "@expo/vector-icons";
import {
  FlatList,
  TextInput,
  TouchableOpacity,
} from "react-native-gesture-handler";
import { API, Auth } from "aws-amplify";
import { updateUsers } from "../src/graphql/mutations";
import qs from "qs";
import { getBooks, listReviews, listUsers } from "../src/graphql/queries";

export default function MyInfo({ navigation }) {
  const userData = useContext(UserContext);
  let user;
  if (userData != null) user = userData.user;
  const [showAvatar, setShowAvatar] = useState(false);
  const [changeUser, setChangeUser] = useState(false);
  const [name, setName] = useState(user.data.getUsers.userName);
  const [books, setBooks] = useState([]);
  const [filteredReviews, setFilteredReviews] = useState([]);

  const transactions = user.data.getUsers.borrowerTransactions.items;
  let notClaimed = true;
  // stores all dates to check whether any are the same
  let dates = [];

  if (transactions != null) {
    transactions.map((transaction) => {
      let date1 = new Date(transaction.returnedDate).getTime();
      let date2 = new Date(transaction.borrowdate).getTime();
      if (
        date1 >= date2 + 259200000 &&
        transaction.returnedDate != null &&
        date1 > user.data.getUsers.rewardDate
      )
        dates.push(date2);
    });
  }
  dates.sort();
  let counter = 1;
  if (dates.length == 0) counter = 0;
  let validDate = dates[0];
  for (let i = 1; i < dates.length; i++) {
    if (dates[i] - validDate >= 259200000) {
      counter++;
      validDate = dates[i];
    }
  }
  if (counter >= 10) {
    counter = 10;
    notClaimed = false;
  }

  useEffect(() => {
    userData.refreshUser();
    getReviews();
  }, [changeUser, notClaimed]);

  async function changeUserName() {
    try {
      await API.graphql({
        query: updateUsers,
        variables: {
          input: {
            uId: user.data.getUsers.uId,
            userName: name,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function checkName() {
    let unique = true;
    const allUsers = await API.graphql({ query: listUsers });
    const users = allUsers.data.listUsers.items;
    users.map((u) => {
      if (
        u.userName.toLowerCase() == name.toLowerCase() &&
        u.userName != user.data.getUsers.userName
      )
        unique = false;
    });
    return unique;
  }

  async function getReviews() {
    const allReviews = await API.graphql({ query: listReviews });
    const reviews = allReviews.data.listReviews.items;
    const myReviews = reviews.filter(
      (review) =>
        review.reviewer.uId == user.data.getUsers.uId && review.favorite
    );
    setFilteredReviews(myReviews);
    let favBooks = [];
    await Promise.all(
      myReviews.map(async (review) => {
        const book = await API.graphql({
          query: getBooks,
          variables: { bookId: review.booksReviewsBookId },
        });
        favBooks.push(book.data.getBooks);
      })
    );
    setBooks(favBooks);
  }

  // opens up mail, then u can send an email to me. WONT WORK with students.
  // need some other method to notify me
  async function sendEmail() {
    let url = `mailto:${"mishtybansal3@gmail.com"}`;
    const query = qs.stringify({
      subject: user.data.getUsers.userName + " has won a gift card.",
      body: "id of the user who has won: " + user.data.getUsers.uId,
      cc: "vikas.bansal@gmail.com",
    });

    if (query.length) {
      url += `?${query}`;
    }

    try {
      const canOpen = await Linking.canOpenURL(url);

      if (!canOpen) {
        throw new Error("Provided URL can not be handled");
      }
      Linking.openURL(url);
    } catch (evt) {
      console.log(evt);
    }
  }

  // figure out how to change this to an email
  async function sendMeNotif() {
    fetch("https://exp.host/--/api/v2/push/send", {
      method: "POST",
      header: {
        Accept: "application/json",
        "Accept-encoding": "gzip, deflate",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: "ExponentPushToken[1ki1rELkPiGPg-NbtBYOuu]",
        sound: "default",
        title: user.data.getUsers.userName + " has won a gift card.",
        body: "id of the user who has won: " + user.data.getUsers.uId,
      }),
      data: "Starbucks giftcard",
    });
  }

  async function storeValidDate() {
    try {
      await API.graphql({
        query: updateUsers,
        variables: {
          input: {
            uId: user.data.getUsers.uId,
            rewardDate: validDate,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  }

  return (
    <View style={styles.container}>
      <ChooseAvatar
        showAvatar={showAvatar}
        setShowAvatar={setShowAvatar}
        user={user}
        refresh={() => {
          userData.refreshUser();
        }}
      />
      <Ionicons
        name={"arrow-back"}
        size={30}
        color={"#6e4732"}
        style={{ marginLeft: 10 }}
        onPress={() => {
          navigation.navigate("Communities");
        }}
      />
      <View style={styles.insideContainer}>
        <View
          style={{
            alignItems: "center",
            marginTop: -120,
            justifyContent: "center",
          }}
        >
          {user.data.getUsers.profilePicture == null ? (
            <Ionicons
              name="md-person-circle-outline"
              color="#a48578"
              size={200}
            />
          ) : (
            <Image
              source={{
                uri: user.data.getUsers.profilePicture,
                width: 200,
                height: 200,
              }}
              style={{ borderRadius: 500, marginBottom: 10, marginTop: 20 }}
            />
          )}
          <TouchableOpacity
            onPress={() => {
              setShowAvatar(!showAvatar);
            }}
          >
            <Text
              style={{
                ...globalStyles.paragraph,
                color: "#4287f5",
                fontFamily: "quicksand-bold",
                marginTop: 0,
                fontSize: 20,
              }}
            >
              Change Avatar
            </Text>
          </TouchableOpacity>
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              marginRight: 20,
              marginLeft: 20,
            }}
          >
            {changeUser ? (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <TextInput
                  style={styles.nameInput}
                  placeHolder={user.data.getUsers.userName}
                  onChangeText={(text) => {
                    setName(text);
                  }}
                  value={name}
                />
                <Ionicons
                  onPress={async () => {
                    const unique = await checkName();
                    if (unique) changeUserName();
                    else {
                      Alert.alert("This username has already been taken.");
                      if (Platform.OS == "web")
                        window.confirm("This username has already been taken.");
                    }
                    setChangeUser(false);
                    setName("");
                  }}
                  name={"checkmark-circle"}
                  size={35}
                  color="#6e4732"
                  style={{ marginTop: 10 }}
                />
              </View>
            ) : (
              <View style={{ flexDirection: "row", marginHorizontal: 10 }}>
                <Text
                  style={{
                    ...globalStyles.titleText,
                    letterSpacing: 1.5,
                    marginTop: 0,
                  }}
                >
                  {user.data.getUsers.userName.toUpperCase()}
                </Text>
                <Ionicons
                  onPress={() => {
                    setChangeUser(true);
                  }}
                  name={"pencil"}
                  size={25}
                  style={{ marginLeft: 10, marginTop: 5 }}
                  color="#6e4732"
                />
              </View>
            )}
          </View>
          <View style={styles.statsStyle}>
            <View style={{ ...styles.iconStyle, borderLeftWidth: 0 }}>
              <Text style={styles.iconTitle}>Shared</Text>
              <Ionicons name={"paper-plane"} size={25} color={"#e2cfc2"} />
              <Text
                style={{ ...styles.iconTitle, marginTop: 5, color: "white" }}
              >
                {user.data.getUsers.ownBooks.items.length + " books"}
              </Text>
            </View>
            <View style={{ ...styles.iconStyle }}>
              <Text style={styles.iconTitle}>Borrowed</Text>
              <Ionicons name={"book"} size={25} color={"#e2cfc2"} />
              <Text
                style={{ ...styles.iconTitle, marginTop: 5, color: "white" }}
              >
                {user.data.getUsers.borrowerTransactions.items.length +
                  " books"}
              </Text>
            </View>
            <View style={styles.iconStyle}>
              <Text style={styles.iconTitle}>Recommended</Text>
              <Ionicons name={"thumbs-up"} size={25} color={"#e2cfc2"} />
              <Text
                style={{ ...styles.iconTitle, marginTop: 5, color: "white" }}
              >
                {" "}
                {filteredReviews.length + " books"}
              </Text>
            </View>
          </View>
        </View>
        <Text style={styles.titleText}>YOUR PROGRESS</Text>
        <View style={styles.back}>
          <LinearGradient
            colors={["#b8a191", "#7c9c7b"]}
            style={{
              ...styles.progressStyle,
              width: (Dimensions.get("window").width * 0.93 * counter) / 10,
            }}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
          ></LinearGradient>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Text
            style={{
              ...styles.subtitleText,
              fontFamily: "quicksand-bold",
              color: "green",
            }}
          >
            {10 - counter + " book(s)"}
          </Text>
          <Text
            style={{
              ...styles.subtitleText,
              fontFamily: "quicksand-bold",
              marginLeft: 2,
            }}
          >
            {"until you win a free $5 Starbucks Card!"}
          </Text>
        </View>
        <View
          style={{
            // flexDirection: "row",
            alignItems: "flex-end",
          }}
        >
          <TouchableOpacity
            onPress={() => {
              Alert.alert(
                "You must borrow a book for at least 3 days for it to be counted." +
                  " Books must be borrowed at least 3 days apart."
              );
              if (Platform.OS == "web")
                window.confirm(
                  "You must borrow a book for at least 3 days for it to be counted." +
                    " Books must be borrowed at least 3 days apart."
                );
            }}
          >
            <Text
              style={{
                ...styles.subtitleText,
                marginRight: 25,
                fontFamily: "quicksand-bold",
                color: "#388dc9",
                marginBottom: 5,
              }}
            >
              TERMS
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={{
              ...styles.buttonStyle,
              backgroundColor: notClaimed ? "#c4a99d" : "green",
            }}
            disabled={notClaimed}
            onPress={async () => {
              Alert.alert(
                "Congrats! You have won a free Starbucks card! A gift card will be sent to your email within the next 3 days."
              );
              // if (!user.data.getUsers.student) await sendEmail();
              await sendMeNotif();
              await storeValidDate();
              notClaimed = true;
              counter = 0;
            }}
          >
            <Text
              style={{
                ...styles.buttonText,
                color: notClaimed ? "#e2cfc2" : "white",
              }}
            >
              CLAIM
            </Text>
            <Image
              source={require("../assets/Starbucks.png")}
              style={{ width: 30, height: 30, opacity: notClaimed ? 0.7 : 1 }}
            />
          </TouchableOpacity>
        </View>
        <Text
          style={{
            ...styles.titleText,
            fontFamily: "quicksand-bold",
            fontSize: 25,
            marginLeft: 10,
            marginTop: 0,
          }}
        >
          YOUR FAVORITES
        </Text>
        <FlatList
          horizontal={true}
          data={books}
          style={{
            marginVertical: 10,
          }}
          renderItem={(book) => (
            <View>
              <Image
                source={{
                  width: 140,
                  height: 200,
                  uri: book.item.Image,
                }}
                style={styles.imageStyle}
              />
            </View>
          )}
        />
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-evenly",
            marginBottom: 15,
          }}
        >
          <Pressable
            onPress={async () => {
              if (Platform.OS == "web") await signOut();
              Alert.alert(
                "Sign out?",
                "are you sure you would like to sign out?",
                [
                  { text: "No" },
                  {
                    text: "Yes",
                    onPress: async () => {
                      await signOut();
                    },
                  },
                ]
              );
            }}
          >
            <Text style={styles.text}>Sign Out</Text>
          </Pressable>
          <Pressable
            onPress={async () => {
              if (Platform.OS == "web")
                if (
                  window.confirm(
                    "are you sure you would like to delete your account? All your data will be lost"
                  )
                )
                  // await deleteAccount();
                  Alert.alert(
                    "Delete account?",
                    "are you sure you would like to delete your account? All your data will be lost",
                    [
                      { text: "No" },
                      {
                        text: "Yes",
                        onPress: async () => {
                          // await deleteAccount();
                        },
                      },
                    ]
                  );
            }}
          >
            <Text
              style={{
                ...styles.text,
                color: "#de8781",
                marginBottom: 10,
              }}
            >
              Delete Account
            </Text>
          </Pressable>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginTop: 50,
  },
  insideContainer: {
    backgroundColor: "#E2CFC2",
    marginTop: 100,
    borderTopLeftRadius: 50,
    borderTopEndRadius: 50,
    flex: 1,
  },
  titleText: {
    fontFamily: "quicksand-normal",
    marginTop: 10,
    marginLeft: 20,
    color: "#80685e",
    fontSize: 20,
  },
  back: {
    backgroundColor: "#c4b8af",
    borderRadius: 20,
    padding: 20,
    marginHorizontal: 15,
    marginTop: 5,
    height: 30,
  },
  progressStyle: {
    height: 40,
    position: "absolute",
    borderRadius: 20,
    borderTopRightRadius: 40,
    borderBottomRightRadius: 40,
    marginTop: Platform.OS == "web" && -20,
    marginLeft: Platform.OS == "web" && -20,
  },
  nameInput: {
    ...globalStyles.input,
    fontSize: 20,
    color: "#6e4732",
    fontFamily: "quicksand-bold",
    borderBottomColor: "#6e4732",
    borderRadius: 10,
    padding: 15,
    width: 200,
    backgroundColor: "#dbccc1",
    marginTop: 5,
  },
  subtitleText: {
    fontFamily: "quicksand-normal",
    color: "#6e4732",
    marginLeft: 20,
    fontSize: 17,
    marginTop: 5,
  },
  buttonStyle: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "green",
    borderRadius: 20,
    padding: 5,
    marginRight: 20,
  },
  buttonText: {
    ...globalStyles.paragraph,
    color: "white",
    fontFamily: "quicksand-bold",
  },
  imageStyle: {
    marginLeft: 10,
    marginRight: 5,
    borderRadius: 7,
    borderWidth: 2,
    borderColor: "#c7bab1",
    shadowOffset: { width: 2, height: 2 },
    shadowColor: "black",
    marginBottom: 10,
  },
  text: {
    fontFamily: "quicksand-bold",
    color: "#4287f5",
    fontSize: 20,
    textAlign: "center",
  },
  statsStyle: {
    flexDirection: "row",
    backgroundColor: "#665249",
    padding: 10,
    marginTop: 10,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "space-between",
    width: Dimensions.get("screen").width * 0.9,
  },
  iconStyle: {
    // marginHorizontal: 25,
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    marginRight: 2,
    borderLeftWidth: 1,
    borderLeftColor: "white",
    paddingHorizontal: 5,
    // marginLeft: 50,
  },
  iconTitle: {
    color: "#e2cfc2",
    fontFamily: "quicksand-bold",
    marginBottom: 5,
  },
});
